export default __webpack_public_path__ + "static/cabin-image-201a2dd8b9ab913697b080bc76f948ad.png";